import { render } from "./DashBoard.vue?vue&type=template&id=6dff6aed&scoped=true&ts=true"
import script from "./DashBoard.vue?vue&type=script&lang=ts"
export * from "./DashBoard.vue?vue&type=script&lang=ts"

import "./DashBoard.vue?vue&type=style&index=0&id=6dff6aed&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dff6aed"]])

export default __exports__